var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.siteHeaderCheckDone && !_vm.hasSiteHeader),expression:"siteHeaderCheckDone && !hasSiteHeader"}],class:{ isSticky: _vm.isSticky },attrs:{"id":"plius-promotion-line"}},[_c('AdFormBanner',{attrs:{"ad-type":"siteheader","settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }